<template>
  <div class="tabs-widget">
    <div class="tab-item" :class="{ active: activeTab == 'music' }" @click="switchTab('music')">
      MUSIC
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'movies' }" @click="switchTab('movies')">
      MOVIES
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'education' }" @click="switchTab('education')">
      EDUCATION
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'podcast' }" @click="switchTab('podcast')">
      PODCAST
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'others' }" @click="switchTab('others')">
      OTHERS
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'playlist' }" @click="switchTab('playlist')">
      PLAYLIST
    </div>
    <div class="h-spacer"></div>
    <div class="tab-item" :class="{ active: activeTab == 'uploaded' }" @click="switchTab('uploaded')">
      UPLOADED
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  sockets: {},
  props: {
    activeTab: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
  display: flex;
  align-items: flex-end;
  margin-right: 15px;

  .h-spacer {
    margin-right: 20px;
  }

  .tab-item {
    cursor: pointer;
    padding: 14px 4px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;

    &.active {
      color: var(--wecodefy-secondary-color, #9fc953);
      border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
    }
  }
}
</style>